import { graphql } from 'relay-runtime';

export const GET_EXISTING_OR_NEW_PROFILE_FOR_KHOROS = graphql`
  mutation GetExistingOrNewProfileFromKhorosUserIdMutation(
    $khorosUserId: String!
  ) {
    unified {
      profile {
        getExistingOrNewProfileFromKhorosUserId(khorosUserId: $khorosUserId) {
          errors {
            code
            extensions {
              errorType
              statusCode
            }
            message
          }
          success
          unifiedProfile {
            accountInternalId
            aaid
            id
            internalId
            username
          }
        }
      }
    }
  }
`;
